import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer";
import Chat from "./../../../components/Chat/index";

const CompanyCustomerSupport = () => {
  return (
    <NavigationDrawer>
      <Chat />
    </NavigationDrawer>
  );
};

export default CompanyCustomerSupport;
